import React from "react";
import styled from "styled-components";
import KakaoAdfit1 from "../KakaoAdfit/KakaoAdfit1";
import KakaoAdfit2 from "../KakaoAdfit/KakaoAdfit2";
import KakaoAdfit3 from "../KakaoAdfit/KakaoAdfit3";
import KakaoAdfit4 from "../KakaoAdfit/KakaoAdfit4";
import { isMobile } from "../common/style";
import { useNavigate } from "react-router-dom";
import StartFaceImg from "../common/image/game/얼굴.png";

const StartPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Center>
      <h1>대머리를 조심해!</h1>
      <Container>
        <StartBtnDiv>
          <img src={StartFaceImg} alt="얼굴" />
          <button onClick={() => navigate("/game")}>시작 하기</button>
        </StartBtnDiv>
        <GameDiv>
          <h2>게임 방법</h2>
          <h3>
            [시작하기] 버튼을 누르면 게임이 시작됩니다. <br />
            10초 동안 바람이 불 때마다 버튼을 클릭하세요! <br />
            바람이 불 때 버튼을 누르지 못하면 머리가 날아가요
          </h3>
        </GameDiv>
      </Container>
      <KakaoAdfitDiv1>
        <KakaoAdfit1 />
      </KakaoAdfitDiv1>
      <KakaoAdfitDiv2>
        <KakaoAdfit2 />
      </KakaoAdfitDiv2>
      <KakaoAdfitDiv>
        <KakaoAdfit3 />
        <KakaoAdfit4 />
      </KakaoAdfitDiv>
    </Center>
  );
};

export default StartPage;

const Center = styled.div`
  display: flex;
  position: fixed;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  left: 0;
  right: 0;
  transition: 0.5s;

  h1 {
    font-size: 27px;
    font-weight: 700;
    line-height: 150%;
    font-family: GmarketSansBold;
    color: #edc1c1;

    margin-top: 63px;
    margin-bottom: 50px;

    ${isMobile} {
      font-size: 22px;
      margin-top: 35px;
      margin-bottom: 20px;
    }
  }
`;

const Container = styled.div`
  height: 500px;

  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${isMobile} {
    height: 380px;
  }
`;

const StartBtnDiv = styled.div`
  position: relative;
  display: flex;
  justify-content: center;

  img {
    position: absolute;
    width: 150px;

    ${isMobile} {
      width: 100px;
    }
  }

  button {
    position: absolute;
    width: 165px;
    height: 80px;
    border-radius: 100px;
    border: 3px solid #edb4b4;
    background: #fff;
    margin-top: 130px;

    color: #d48f8f;
    text-align: center;
    font-family: GmarketSansBold;
    font-size: 25px;
    font-weight: 700;

    cursor: pointer;

    &:hover {
      background: #ffeaea;
    }

    ${isMobile} {
      width: 140px;
      height: 60px;
      margin-top: 90px;
      border: 2px solid #edb4b4;
      font-size: 20px;
    }
  }
`;

const GameDiv = styled.div`
  width: 500px;
  height: 220px;
  border-radius: 40px;
  border: 3px dashed #d48f8f;
  margin-top: 228px;

  ${isMobile} {
    width: 270px;
    height: 210px;
    border-radius: 30px;
    margin-top: 160px;
    border: 2px dashed #d48f8f;
  }

  h2 {
    color: #d48f8f;
    text-align: center;
    font-family: GmarketSansBold;
    font-size: 25px;
    font-weight: 700;
    margin-top: 24px;
    margin-bottom: 16px;

    ${isMobile} {
      font-size: 18px;
      margin-top: 11px;
      margin-bottom: 9px;
    }
  }

  h3 {
    color: #de9999;
    text-align: center;
    font-family: GmarketSansBold;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 39px;

    ${isMobile} {
      padding: 0 20px;
      font-size: 14px;
      line-height: 25px;
      word-break: keep-all;
    }
  }
`;

const KakaoAdfitDiv1 = styled.div`
  margin-top: 100px;
  margin-right: 920px;
  position: absolute;
`;

const KakaoAdfitDiv2 = styled.div`
  margin-top: 100px;
  margin-left: 920px;
  position: absolute;
`;

const KakaoAdfitDiv = styled.div`
  position: relative;
`;
